import { CoverLot } from '@/types/CoverLot';
import { ItemSummary } from '@/types/item/ItemSummary';
import { getImageUrl } from '@/utils/urls';

/** TEMP: BUGS-7136 — delete this file when item-api always returns coverLots. */
export const COVER_LOTS_COUNT = 3;

export const hasRealCoverLots = (coverLots: CoverLot[]) => coverLots.some((coverLot) => coverLot.itemId > 0);

export const itemSummaryToCoverLot = (item: ItemSummary): CoverLot => ({
    imageVersion: item.imageVersion,
    itemId: item.itemId,
    title: item.title,
    url: getImageUrl({
        catalogId: item.catalogId,
        imageNumber: item.photos?.[0],
        imageVersion: item.imageVersion,
        itemId: item.itemId,
        sellerId: item.sellerId,
    }),
});

export const getCoverLotsWithItemFallback = (coverLots: CoverLot[], itemSummaries: ItemSummary[]): CoverLot[] => {
    if (hasRealCoverLots(coverLots)) {
        return coverLots.filter((coverLot) => coverLot.itemId > 0);
    }

    return itemSummaries
        .map(itemSummaryToCoverLot)
        .filter((coverLot) => coverLot.itemId > 0 && coverLot.url)
        .slice(0, COVER_LOTS_COUNT);
};
